import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicantDetailsComponent } from '../applicant-details/applicant-details.component';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';  // Add this import
import { LoginService } from 'src/app/core/services/login.service';
import { log } from 'node:console';
import { FeedDocumentComponent } from 'src/app/modules/feeds/pages/feed-document/feed-document.component';
import { M } from '@angular/cdk/keycodes';
import { BasicInfoTabService } from 'src/app/modules/dashboard/modules/my-directory/services/basic-info-tab.service';
import { PermissionDeniedModalComponent } from 'src/app/modules/home/components/permission-modal/permission-denied-modal.component';
import { Subject } from 'rxjs';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { JobDetailsPreviewComponent } from '../job-details-preview/job-details-preview.component';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';

@Component({
  selector: 'app-job-listing',
  templateUrl: './job-listing.component.html',
  styleUrls: ['./job-listing.component.scss'],
})
export class JobListingComponent implements OnInit {
  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  @ViewChild(CdkVirtualScrollViewport) roleViewport!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport) companyViewport!: CdkVirtualScrollViewport;
receivedId: any;
  jobSeekPermissionLimit: number = Infinity; // default to allow all if not found
  selectedStatus: string = 'ALL';
  OpenFilter = false;
  listingBlock: any = false;
  singleJob: any;
  applicants: any;
  filteredJobs: any;
  filteredApplicants: any;
  loginDetails: any;
  selectedActiveStatus: string;
  showPopup: boolean = false;
  jobList = [];
  jobsTabCounts;

  limit = 10;
  offset = 0;
  loadingJobs = false;
  // filterForm = {
  //   company_name: '',
  //   j_role: '',
  //   status: '',
  //   TypeofEmployment: ''
  // };
  companyOptions: string[] = [];
  roleOptions: string[] = [];
  // empTypeOptions: string[] = [];
  searchSubject = new Subject<void>();

  getRole: any[] = [];
  getEmpType: any[] = [];
  selectedTabStatus: string = 'ALL';
  openAccordionId: string | null = null;
  openEnquiryAccordionId: string | null = null;
  newMessage: string = '';
  EditedMessageId: string = '';
  DisplayMessage: any[];
  filterEnquiry: any[] = [];
  enquiryMessage: any[];
  EnquiriesMessage: any[];
  appliedMessage: any[];
  AllDataCount: any[];
  directory: any;
  jobsCount: any;
  showCreateButton: boolean;

  status: '';
  TypeofEmployment: '';

  hasMoreJobs = true;
  loaderJobList = false;

  constructor(
    private jobService: PostnewJob,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private _dialog: MatDialog,
    private toast: ToastService,
    private router: Router,
    private loginService: LoginService,
     private route: ActivatedRoute, 
    private basicInfoTabService: BasicInfoTabService,
    private commonService:CommonServicesForAllModules
  ) { }

  ngOnInit(): void {

      this.route.queryParams.subscribe(params => {
    
     this.receivedId = params['id'];
        if (this.receivedId) {

          this.selectedStatus = 'PENDING';
          this.offset = 0;
          this.jobList = [];
          this.fetchJobs();

        }
 
      });





    this.loginDetails = this.loginService.getLoginData()
    const jobPermission = this.loginDetails?.subscription_permissions?.modules
      ?.find((mod: any) => mod.name === 'job_seek_modules_permission');

    this.showCreateButton = true;
    if (jobPermission?.permission) {
      this.jobSeekPermissionLimit = jobPermission.count;
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      const andList: any[] = [
        {
          status: { "_in": ["APPROVE", "PENDING", "INACTIVE"] }
        },
        {
          created_at: {
            _gte: startDate.toISOString(),
            _lt: endDate.toISOString()
          }
        }
      ];
      if (this.loginDetails.type == "SUPPLIER") {
        andList.push({
          dental_supplier_id: { _eq: this.loginDetails.id }
        });
      }
      if (this.loginDetails.type == "PRACTICE") {
        andList.push({
          dental_practice_id: { _eq: this.loginDetails.id }
        });
      }
      this.jobService.getMonthlyJobsCount(andList).subscribe(data => {
        this.jobsCount = data;
        if (this.jobSeekPermissionLimit != -1) {
          let remainingCount = this.jobSeekPermissionLimit - this.jobsCount;
          if (remainingCount <= 0) {
            this.showCreateButton = false;
          }
        }
      });

    }

    if (this.loginDetails.type == "SUPPLIER") {
      this.basicInfoTabService.userSupDirectory(this.loginDetails.id).subscribe(data => {
        this.directory = data[0];
        //   if (data['length'] == 0) {
        //     this.router.navigate(['/profile/directory']);
        //   } 
      });
    }
    this.spinner.show();

    this.fetchJobs();
    this.loadJobTabCounts();

    if (this.loginDetails.type == 'ADMIN') {
      this.loadCompanies();
      this.loadRoles();
      this.loadEmpTypes();
      this.loadFilterStatus();
    }

    // filter company options
    this.companyCtrl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          this.showCompanyDropdown = true;
          this.loadCompanies(true); // reset and fetch
        })
      )
      .subscribe();

    // filter role option
    this.roleCtrl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          this.showRoleDropdown = true; // always open dropdown
          this.loadRoles(true); // reset + fetch
        })
      )
      .subscribe();


    // employeetype:
    this.empTypeCtrl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          this.showEmpTypeDropdown = true;
          this.loadEmpTypes(true); // reset + fetch
        })
      )
      .subscribe();

    // status filter option
    this.statusCtrl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          this.showStatusDropdown = true;
          this.loadFilterStatus(true); // reset + fetch
        })
      )
      .subscribe();

  }

  // === FILTER FUNCTIONS ===

  // isExpired(job: any): boolean {
  //   return job?.closed_at && new Date(job.closed_at) < new Date();
  // }

  async updateStatus(jobId: string, newStatus: 'ACTIVE' | 'INACTIVE'): Promise<void> {
    if (!jobId) return;
    const payload = { active_status: newStatus};
    try {
      await this.commonService.UpdateData(Tables.Jobs, jobId, payload);
      this.offset = 0;
      this.jobList = [];
      this.refreshJobs();
      this.loadJobTabCounts();
      this.toast.openSnackBar(`Job profile ${newStatus === 'ACTIVE' ? 'ACTIVE' : 'INACTIVE'} successfully`);
    } catch (err) {
      console.error('Failed to update job active status:', err);
      this.toast.openSnackBar('Updating active status failed');
    }
  }



  // -------------------------

  async deleteJob(job: any): Promise<void> {
    if (!job?.id) return;

    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: job.id,
        name: 'Job Profile',
      },
    });

    const response = await dialogRef.afterClosed().toPromise();
    if (response !== 'yes') return; 
    try {
      await this.commonService.DeleteById(Tables.Jobs, job.id);
      this.toast.openSnackBar('Job profile deleted successfully');
      this.offset = 0;
      this.jobList = [];
      this.refreshJobs();
      this.loadJobTabCounts();
    } catch (err) {
      console.error('Job deletion failed:', err);
      this.toast.openSnackBar('Unable to delete job profile');
    }
  }

  editJob(job: any): void {
    this.router.navigate(['/profile/list-job-post/edit', job.id]);
  }

  // viewJob(job: any): void {
  //   this.router.navigate(['/jobseek/jobdetails', job.id]);
  // }

  // viewJob(jobs: any): void {
  //   console.log('jobs jobs', jobs)

  //   this.dialog.open(JobDetailsPreviewComponent, {
  //     width: '60%',
  //     panelClass: ['custom-modal'],
  //     data: {
  //       ...jobs,
  //     }
  //   });
  // }

    viewJob(jobId: string | number): void {
  
      this.dialog.open(JobDetailsPreviewComponent, {
        width: '60%',
        panelClass: ['custom-modal'],
        data: { id: jobId }   // send only the id
      });
    }
  
  async updateJobStatus(jobId: any, newStatus: 'APPROVE' | 'REJECT'): Promise<void> {
    if (!jobId) return;
    const updateData = { status: newStatus };
    try {
      await this.commonService.UpdateData(Tables.Jobs, jobId, updateData);
      this.toast.openSnackBar(`Job profile ${newStatus === 'APPROVE' ? 'Approved' : 'Rejected'} successfully`);
      this.offset = 0;
      this.jobList = [];
      this.refreshJobs();
      this.loadJobTabCounts();
          // Remove 'id' from query params after approval or rejection
    this.router.navigate([], {
      queryParams: { id: null },
      queryParamsHandling: 'merge', // keeps other params intact
    });
    } catch (err) {
      console.error(`Job profile ${newStatus} failed:`, err);
      this.toast.openSnackBar(`${newStatus} Failed`);
    }
  }


  filterToggle(): void {
    // this.loadFilterDropdownOptions();
    this.searchSubject.pipe(debounceTime(400)).subscribe(() => {
      this.offset = 0;
      this.jobList = [];
      this.fetchJobs();
    });
    this.OpenFilter = !this.OpenFilter;

    // if (this.OpenFilter) {
    //   // Load initial companies
    //   this.loadCompanies();
    //   this.loadRoles();
    //   this.loadEmpTypes();
    //   this.loadFilterStatus();
    // }
  }

  feeddocumentView(doc: any) {
    if (doc) {
      this._dialog.open(FeedDocumentComponent, {
        width: '40%',
        panelClass: ['custom-modal'],
        data: doc,
      });
    }
  }


  hasReachedJobLimit(): boolean {
    return this.filteredJobs?.length >= this.jobSeekPermissionLimit;
  }
  private showAccessDenied(message: string, userType?: string): void {
    this.dialog.open(PermissionDeniedModalComponent, {
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
      width: '30%',
      data: {
        message: message,
        showContactAdmin: true,
        userType: userType,
      },
    });
  }

  handleCreateJobClick(): void {
    if (!this.showCreateButton) {
      this.showAccessDenied(
        'You have reached the maximum number of job posts allowed under your current subscription.',
        this.loginDetails?.type
      );
    } else {
      this.router.navigate(['/profile/job-post']);
    }
  }


  refreshJobs(): void {
    this.offset = 0;
    this.hasMoreJobs = true;
    this.jobList = [];
    this.fetchJobs();
  }

  fetchJobs() {
    if (this.loadingJobs || !this.hasMoreJobs) return;
    this.loadingJobs = true;

    this.jobService
      .getFilteredJobs(
        this.limit,
        this.offset,
        this.selectedStatus,
        this.selectedEmpType,
        this.selectedCompany,
        this.selectedRole,
        this.selectedFilterStatus
      )
      .subscribe((res: any[]) => {
        if (res?.length) {
          this.jobList = [...this.jobList, ...res];
          this.offset += this.limit;
        } else {
          this.hasMoreJobs = false;
        }
        this.loaderJobList = false;
        this.loadingJobs = false;
        this.spinner.hide();
      });
  }

  onScroll() {
    if (this.hasMoreJobs && !this.loadingJobs) {
      this.fetchJobs();
    }
  }

  selectStatus(status: string) {
    this.loaderJobList = true;
    this.selectedStatus = status;
    this.offset = 0;
    this.jobList = [];
    this.selectedFilterStatus = '';
    this.statusCtrl.setValue('', { emitEvent: false });
    this.refreshJobs();
    this.loadJobTabCounts();
  }

  loadJobTabCounts(): void {
    this.jobService.getJobsTabCounts().subscribe((res: any) => {
      this.jobsTabCounts = {
        ALL: res?.data?.all?.aggregate?.count || 0,
        DRAFT: res?.data?.draft?.aggregate?.count || 0,
        PENDING: res?.data?.pending?.aggregate?.count || 0,
        ACTIVE: res?.data?.active?.aggregate?.count || 0,
        INACTIVE: res?.data?.inactive?.aggregate?.count || 0,
        EXPIRED: res?.data?.expired?.aggregate?.count || 0,
        APPROVE: res?.data?.approved?.aggregate?.count || 0,
        REJECTED: res?.data?.rejected?.aggregate?.count || 0,
      };
    });
  }

  onFilterChange(): void {
    this.offset = 0;
    this.loaderJobList =true;
    this.hasMoreJobs = true;
    this.jobList = [];
    this.fetchJobs();
  }


  clearAllFilters() {
    const isAlreadyCleared =
      !this.selectedCompany?.trim() &&
      !this.selectedRole?.trim() &&
      !this.status?.trim() &&
      !this.selectedEmpType?.trim() &&
      !this.selectedFilterStatus?.trim() &&

      !this.companyCtrl.value?.trim() &&
      !this.roleCtrl.value?.trim() &&
      !this.empTypeCtrl.value?.trim() &&
      !this.statusCtrl.value?.trim();


    if (isAlreadyCleared) {
      return;
    }
    this.status = '';
    this.TypeofEmployment = '';
    this.offset = 0;
    this.jobList = [];

    this.companyCtrl.setValue('', { emitEvent: false });
    this.selectedCompany = '';
    this.companies = [];
    this.showCompanyDropdown = false;
    this.loadCompanies();

    this.roleCtrl.setValue('', { emitEvent: false });
    this.selectedRole = '';
    this.roles = [];
    this.showRoleDropdown = false;
    this.loadRoles();


    this.empTypeCtrl.setValue('', { emitEvent: false });
    this.selectedEmpType = '';
    this.empTypeOptions = [];
    this.showEmpTypeDropdown = false;
    this.loadEmpTypes();

    this.statusCtrl.setValue('', { emitEvent: false });
    this.selectedFilterStatus = '';
    this.statusOptions = [];
    this.showEmpTypeDropdown = false;
    this.loadFilterStatus();

     this.loaderJobList =true;
    this.refreshJobs();
  }

  getJobTypes(typeOfEmployment: any): string[] {
    if (!typeOfEmployment) return [];
    return Array.isArray(typeOfEmployment)
      ? typeOfEmployment
      : [typeOfEmployment];
  }
  trackByJobId(index: number, job: any): string {
    return job.id;
  }


  ifSelectedId: boolean = false;
  selectedJobDetails: any = null;
  selectedJobId: string | null = null;

  selectedJob(job: any) {

    this.selectedJobDetails = job;
    this.selectedJobId = job.id;
    this.ifSelectedId = true;
  }

  viewAllFlag: boolean = false;

  handleViewAllClick() {
    this.viewAllFlag = true;
    this.ifSelectedId = false;
  }

  handleBackToList() {
    this.ifSelectedId = false;
    this.viewAllFlag = false;
  }


  // new companyoption filter :

  companyCtrl = new FormControl('');
  companies: any[] = [];
  isLoadingCompanies = false;
  showCompanyDropdown = false;

  companyOffset = 0;
  companyLimit = 10;
  selectedCompany = ''; // used for fetchJobs
  // Load companies from backend
  loadCompanies(reset: boolean = true): void {
    if (this.isLoadingCompanies) return;

    if (reset) {
      this.companyOffset = 0;
      this.companies = [];
    }

    this.isLoadingCompanies = true;
    this.jobService
      .getCompanyName(
        this.companyLimit,
        this.companyOffset,
        this.companyCtrl.value?.trim() || ''
      )
      .subscribe((res) => {


        this.isLoadingCompanies = false;
        if (res?.length) {
          if (reset) {
            this.companies = res; // fresh load
          } else {
            this.companies = [...this.companies, ...res]; // append
          }
          this.companyOffset += this.companyLimit;
        }
      });
  }

  // Infinite scroll for company dropdown
  onCompanyScrolled(): void {
    if (!this.companyViewport) return;

    const end = this.companyViewport.measureScrollOffset('bottom');
    if (end < 50 && !this.isLoadingCompanies) {
      this.loadCompanies(false);
    }
  }

  // Select a company
  selectCompany(name: string): void {
    this.companyCtrl.setValue(name, { emitEvent: false });
    this.selectedCompany = name;
    this.showCompanyDropdown = false;
    this.onFilterChange();
  }

  hideDropdown(type: string) {
    setTimeout(() => {
      if (type === 'company') this.showCompanyDropdown = false;
      if (type === 'role') this.showRoleDropdown = false;
      if (type === 'empType') this.showEmpTypeDropdown = false;
      if (type === 'status') this.showStatusDropdown = false;
    }, 150);
  }

  // role option filter
  // Role controls
  roleCtrl = new FormControl('');
  roles: any[] = [];
  isLoadingRoles = false;
  showRoleDropdown = false;

  roleOffset = 0;
  roleLimit = 10;
  selectedRole = ''; // used for fetchJobs


  // Load roles from backend
  loadRoles(reset: boolean = true): void {
    if (this.isLoadingRoles) return;

    if (reset) {
      this.roleOffset = 0;
      this.roles = [];
    }

    this.isLoadingRoles = true;

    this.jobService
      .getRoleName(this.roleLimit, this.roleOffset, this.roleCtrl.value?.trim() || '')
      .subscribe((res) => {
        this.isLoadingRoles = false;
        if (res?.length) {
          if (reset) {
            this.roles = res; // fresh load
          } else {
            this.roles = [...this.roles, ...res]; // append more
          }
          this.roleOffset += this.roleLimit;
        }
      });
  }

  onRoleScrolled(): void {
    const end = this.roleViewport.measureScrollOffset('bottom');
    if (end < 50 && !this.isLoadingRoles) {
      this.loadRoles(false); // fetch more
    }
  }

  // Select a role
  selectRole(name: string): void {
    this.roleCtrl.setValue(name, { emitEvent: false });
    this.selectedRole = name;
    this.showRoleDropdown = false;
    this.onFilterChange();
  }


  // Employee Type controls
  empTypeCtrl = new FormControl('');
  empTypeOptions: string[] = [];
  isLoadingEmpType = false;
  showEmpTypeDropdown = false;

  empTypeOffset = 0;
  empTypeLimit = 10;
  selectedEmpType = ''; // used for filtering

  @ViewChild('empTypeViewport') empTypeViewport!: CdkVirtualScrollViewport;

  // Load Employee Types from backend
  loadEmpTypes(reset: boolean = true): void {
    if (this.isLoadingEmpType) return;

    if (reset) {
      this.empTypeOffset = 0;
      this.empTypeOptions = [];
    }

    this.isLoadingEmpType = true;

    this.jobService
      .getEmployeeTypes(this.empTypeLimit, this.empTypeOffset, this.empTypeCtrl.value?.trim() || '')
      .subscribe((res: string[]) => {
        this.isLoadingEmpType = false;


        if (res?.length) {
          if (reset) {
            this.empTypeOptions = res;
          } else {
            // Append while avoiding duplicates
            this.empTypeOptions = [...new Set([...this.empTypeOptions, ...res])];
          }

          this.empTypeOffset += this.empTypeLimit;
        }
      });
  }


  // Infinite scroll
  onEmpTypeScrolled(): void {
    if (!this.empTypeViewport) return;
    const end = this.empTypeViewport.measureScrollOffset('bottom');
    if (end < 50 && !this.isLoadingEmpType) {
      this.loadEmpTypes(false);
    }
  }


  // Select Employee Type
  selectEmpType(value: string): void {
    this.empTypeCtrl.setValue(value, { emitEvent: false });
    this.selectedEmpType = value;
    this.showEmpTypeDropdown = false;
    this.onFilterChange(); // trigger filtering or other logic
  }

  // status:

  statusCtrl = new FormControl('');
  statusOptions: any[] = [];
  isLoadingStatus = false;
  showStatusDropdown = false;

  statusOffset = 0;
  statusLimit = 10;
  selectedFilterStatus = ''; // used for fetchJob
  @ViewChild('statusViewport') statusViewport!: CdkVirtualScrollViewport;


  loadFilterStatus(reset: boolean = true): void {
    if (this.isLoadingStatus) return;

    if (reset) {
      this.statusOffset = 0;
      this.statusOptions = [];
    }

    this.isLoadingStatus = true;

    this.jobService
      .getFilterStatus(this.statusLimit, this.statusOffset, this.statusCtrl.value?.trim() || '')
      .subscribe((res) => {
        this.isLoadingStatus = false;
        if (res?.length) {
          if (reset) {
            this.statusOptions = res; // fresh load
          } else {
            this.statusOptions = [...this.statusOptions, ...res]; // append more
          }
          this.statusOffset += this.statusLimit;
        }
      });
  }

  onStatusScrolled(): void {
    const end = this.statusViewport.measureScrollOffset('bottom');
    if (end < 50 && !this.isLoadingStatus) {
      this.loadFilterStatus(false);
    }
  }

  // Select status
  selectFilterStatus(name: string): void {
    this.statusCtrl.setValue(name, { emitEvent: false });
    this.selectedFilterStatus = name;
    this.showStatusDropdown = false;
    this.onFilterChange();
  }



}